import React from "react";
import { FaPhoneAlt, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";

export default function ContactCards() {
  return (
    <section className="contact-section">
      <h2>Contact Us</h2>

      <div className="contact-grid">
        {/* Call Card */}
        <div className="contact-card">
          <div className="contact-icon blue">
            <FaPhoneAlt />
          </div>
          <div>
            <p className="contact-title">Call Us</p>
            <a href="tel:9031062013">+91 9031062013</a>
            <span>Patna, Bihar, India</span>
          </div>
        </div>

        {/* WhatsApp Card */}
        <div className="contact-card">
          <div className="contact-icon green">
            <FaWhatsapp />
          </div>
          <div>
            <p className="contact-title">WhatsApp</p>
            <a href="https://wa.me/919031062013" target="_blank" rel="noreferrer">
              +91 9031062013
            </a>
            <span>Patna, Bihar, India</span>
          </div>
        </div>

        {/* Location Card */}
        <div className="contact-card map-card">
          <iframe
            title="map"
            src="https://www.google.com/maps?q=Patna,Bihar,India&output=embed"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
          <a
            href="https://maps.google.com?q=Patna,Bihar,India"
            target="_blank"
            rel="noreferrer"
            className="direction-btn"
          >
            Get Directions
          </a>
        </div>
      </div>
    </section>
  );
}
